import localization from "../../../assets/localization";
import ChatCache from "../../../utils/ChatCache";

interface ChatHeaderProps {
  style: any;
  isEditor: boolean;
  toggleChatWidget: () => void;
  cleanCache: () => void;
  language: string;
  assistant: any;
  /** Standalone: the chat IS the page, so there is nothing to minimise into. */
  canClose?: boolean;
}

export const ChatHeader = ({
  style,
  isEditor,
  toggleChatWidget,
  cleanCache,
  language,
  assistant,
  canClose = true,
}: ChatHeaderProps) => (
  <div
    className="widget-header"
    style={{ backgroundColor: style.color, borderColor: style.color }}
  >
    <div style={{ display: "flex" }}>
      <img
        src={style.fileUrl}
        alt={localization.get(language).assistant_icon_alt}
        className="header-icon inline-block"
      />
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      {process.env.REACT_APP_IS_PROD !== "yes" && (
        <button
          className="trash-button"
          onClick={() => {
            const data = new ChatCache().getMessages(assistant.id);
            const jsonData = JSON.stringify(data, null, 2); // Pretty print JSON
            const blob = new Blob([jsonData], { type: "application/json" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download =
              "chat_" +
              new Date().toISOString().slice(0, 10).replace(/-/g, "") +
              ".json";
            link.click();
            URL.revokeObjectURL(url);
          }}
          disabled={isEditor}
        >
          <i className="fa-solid fa-download"></i>
        </button>
      )}

      <button
        className="trash-button"
        onClick={cleanCache}
        disabled={isEditor}
        aria-label={localization.get(language).delete_chat_aria_label}
      >
        <i className="fa-solid fa-trash" aria-hidden="true"></i>
      </button>
      {canClose && (
        <button
          className="minimize-button"
          onClick={toggleChatWidget}
          disabled={isEditor}
          aria-label={localization.get(language).close_aria_label}
        >
          <i className="fa-solid fa-x" aria-hidden="true"></i>
        </button>
      )}
    </div>
  </div>
);
